import { render, staticRenderFns } from "./critiqueDetail.vue?vue&type=template&id=85b9de34&"
import script from "./critiqueDetail.vue?vue&type=script&lang=js&"
export * from "./critiqueDetail.vue?vue&type=script&lang=js&"
import style0 from "./critiqueDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports